import React from 'react';
import { Link } from 'react-router-dom';
import BrazilWatchBand from './BrazilWatchBand';

const About = () => {
  // Logos dos clientes - usando todas as imagens da pasta companies
  const clientLogos = [
    '/images/companies/Group 3735.png',
    '/images/companies/image 16.png',
    '/images/companies/image 17.png',
    '/images/companies/image 19.png',
    '/images/companies/image 20.png',
    '/images/companies/image 22.png',
    '/images/companies/image 23.png',
    '/images/companies/LODO - DOM ZOEIRO 1.png',
    '/images/companies/LOGO - MASATE.png',
    '/images/companies/LOGO - SAINT VETSKY (1).png',
    '/images/companies/LOGO - TABERNA GEEK 2.png',
  ];

  const features = [
    {
      title: 'About us',
      icon: '🏛️',
      description: 'The International Arm of <a href="https://www.marcasja.com.br/" target="_blank" rel="noopener noreferrer" class="about-description-link">Marcas Já</a>. We combine the security of a top-tier IP operation with the agility of a tech startup. Backed by 11+ years of market presence, 14,000+ trademarks filed and a 300+ verified five-star Google rating, we are the safe harbor for your IP in Brazil, built specifically to serve international firms and corporate clients.',
      image: '/images/zj02Oip8blCnmxCMKJ1nddMeeu0.jpg',
    },
    {
      title: 'Process efficiency',
      icon: '⚡',
      description: 'Structured filing. Our tech-driven workflow enables 24h filing turnaround and real-time monitoring. We cut through the red tape to deliver one of the fastest "filed-to-certificate" experiences in the Brazilian INPI.',
      image: '/images/zaYWSR4lGQAnI0X2V8E87s17UP4.jpg',
    },
    {
      title: 'Special service',
      icon: '🤝',
      description: 'Your Local Strategic Partner. Tailored specifically for International IP Firms. We act as your "boots on the ground" for clearance, prosecution, and defense, offering expert assistance with flat fees and zero hidden costs.',
      image: '/images/0ZkX196UN8eAcSokGmDK0zIQ4Q.jpg',
    },
  ];

  return (
    <section id="company" className="bg-background-auxiliary relative scroll-mt-24 pb-4 md:pb-6">
      <div className="w-full bg-background-white border-y border-gray-200/60 shadow-sm mb-16 md:mb-20">
        <div className="container mx-auto px-4 py-8 md:py-10">
          <p className="text-center text-xs uppercase tracking-wider text-text/50 font-semibold mb-6 md:mb-8">
            Trusted by brands across Brazil and worldwide
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 lg:gap-8">
            {clientLogos.map((logo, index) => (
              <div key={index} className="flex items-center justify-center h-10 md:h-12 lg:h-14">
                <img
                  src={logo}
                  alt={`Client logo ${index + 1}`}
                  className="h-full w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
            </div>
          </div>
          <BrazilWatchBand />
        </div>

        <div className="container mx-auto px-4">
          {/* Textos acima do About Us */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-4">
          Reliable Prosecution for International Portfolios

          </h2>
          <p className="text-lg text-text/70 max-w-2xl mx-auto">
          Need a Brazil trademark assessment? Request a scope-defined search or filing proposal, with clear fees before work begins.
          </p>
        </div>

        {/* About Us - 3 colunas de texto */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch pb-4 md:pb-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-background-white rounded-2xl p-8 border border-gray-100/50 hover:shadow-md hover:border-primary/30 transition-shadow flex flex-col">
              <div className="mb-5 text-5xl" aria-hidden="true">{feature.icon}</div>
              <h3 className="text-xl font-bold text-text mb-4">
                {feature.title}
              </h3>
              <p className="text-text/70 leading-relaxed about-description" dangerouslySetInnerHTML={{ __html: feature.description }} />
              {feature.title === 'About us' && (
                <Link
                  to="/about"
                  className="mt-4 text-primary hover:text-primary-hover font-semibold text-sm inline-block"
                >
                  Read our full story →
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
